import React from 'react';
import {
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

import DashboardPage from 'pages/Dashboard';
import OrderPage from 'pages/Order';
import SeedingPage from 'pages/Seeding';

import { ROUTES } from 'constants/routes';

const MainRouter = (): JSX.Element => (
  <Switch>
    <Route path={ROUTES.dashboard.root} component={DashboardPage} />
    <Route path={ROUTES.orders.root} component={OrderPage} />
    <Route path={ROUTES.seeding.root} component={SeedingPage} />
    <Route path={['', ROUTES.root]} exact>
      <Redirect to={ROUTES.dashboard.root} />
    </Route>
  </Switch>
);

export default MainRouter;
